import React from 'react';
import { useSelector } from 'react-redux';
import MultiSelectCheckbox from '@awp/components/Common/DropDown/Multiselect/MultiselectCheckbox';
import PropTypes from 'prop-types';

import {
  getDatasetDropdownOptions,
  selectData,
  selectStatus,
  selectHeatMapObservation,
} from '@stores/dataVisualizationSlice';

import { STATE_STATUS } from '@awp/constants';

const MultiSelect = (Props) => {
  const data = useSelector(selectData);
  const status = useSelector(selectStatus);
  const heatMapObservation = useSelector(selectHeatMapObservation);

  const { optionsWithGroup, options } = getDatasetDropdownOptions(data, Props.withImages, {
    frostProbeHeatMapObs: heatMapObservation,
    isGraph: true,
  });
  function getSelectedOptions() {
    let selectedOptions = [];

    if (options !== undefined && Props.selectedOptions !== undefined) {
      selectedOptions = options.filter((opt) => {
        return Props.selectedOptions.some((selOpts) => {
          return selOpts.name === opt.group && selOpts.obstypeid === opt.typeId;
        });
      });
    }
    return selectedOptions;
  }

  function onChange(value) {
    //if the selected options and the state are different sizes then we are updating
    const isUpdateAction = value.length != Props.selectedOptions.length;

    Props.setSelectedOptions(value, isUpdateAction);
  }

  return (
    <>
      {status.data === STATE_STATUS.SUCCESS && (
        <MultiSelectCheckbox
          options={optionsWithGroup || []}
          value={getSelectedOptions()}
          //styles={selectStyles}
          onChange={onChange}
        />
      )}
    </>
  );
};

MultiSelect.propTypes = {
  withImages: PropTypes.bool.isRequired,
  setSelectedOptions: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array,
};

export default MultiSelect;
